<template>
  <v-navigation-drawer
    id="core-navigation-drawer-details"
    v-if="activePage.name && activePage.name.toLowerCase() === 'staff dashboard'"
    v-model="drawerFilterSearch"
    mobile-breakpoint="960"
    app
    right
    width="300"
    v-bind="$attrs"
  >
    <v-row class="flex-column">
      <v-card
        cols="12"
        flat
        class="mx-5"
      >
        Filters
      </v-card>
<!--      DISTANCE-->
      <v-card
        cols="12"
        class="mx-5 pl-3 pt-2"
      >
        Distance
        <v-checkbox
          v-model="searchEnabledFilters.distance"
          label="Use Distance?"
        ></v-checkbox>
        <v-text-field
          v-model="searchFilters.distance"
          label="Distance (miles)"
          style="width: 90%"
        ></v-text-field>
        <v-select
          v-model="searchFilters.distanceOp"
          :items="distanceOperators"
          label="Distance Operator"
        ></v-select>
      </v-card>

<!--      CENTER-->
      <v-card
        cols="12"
        class="mx-5 pl-3 pt-2"
      >
        Center
        <v-checkbox
          v-model="searchEnabledFilters.center"
          label="Use Center?"
        ></v-checkbox>
        <v-text-field
          v-model="searchFilters.center.lat"
          label="Latitude"
          style="width: 90%"
        ></v-text-field>
        <v-text-field
          v-model="searchFilters.center.lng"
          label="Longitude"
          style="width: 90%"
        ></v-text-field>
      </v-card>
      <!--      Rates-->
      <v-card
        cols="12"
        class="mx-5 pl-3 pt-2"
      >
        Rates
        <v-checkbox
          v-model="searchEnabledFilters.rates"
          label="Use Rates?"
        ></v-checkbox>
        <v-select
          v-model="searchFilters.rate_name.value"
          :items="serviceRates"
          label="Rates"
          multiple
        ></v-select>
      </v-card>
      <!--      Towers-->
      <v-card
        cols="12"
        class="mx-5 pl-3 pt-2"
      >
        Towers
        <v-checkbox
          v-model="searchEnabledFilters.tower"
          label="Use Towers?"
        ></v-checkbox>
        <v-select
          v-model="searchFilters.towerNumber.value"
          :items="towerOptions"
          label="Towers"
          multiple
        ></v-select>
      </v-card>
<!--      Radius-->
      <v-card
        cols="12"
        class="mx-5 pl-3 pt-2"
      >
        Radius Group
        <v-checkbox
          v-model="searchEnabledFilters.radius"
          label="Use Radius?"
        ></v-checkbox>
        <v-select
          v-model="searchFilters.radius.value"
          :items="radiusOptions"
          label="Radius Group"
          multiple
        ></v-select>
      </v-card>
<!--      AP Type-->
      <v-card
        cols="12"
        class="mx-5 pl-3 pt-2"
      >
        AP Type
        <v-checkbox
          v-model="searchEnabledFilters.apType"
          label="Use AP Type?"
        ></v-checkbox>
        <v-select
          v-model="searchFilters.apType.value"
          :items="apTypeOptions"
          label="AP Types"
          multiple
        ></v-select>
      </v-card>

      <!--      Active Status-->
      <v-card
        cols="12"
        class="mx-5 pl-3 pt-2"
      >
        Active Status
        <v-checkbox
          v-model="searchEnabledFilters.active"
          label="Use Active Status?"
        ></v-checkbox>
        <v-select
          v-model="searchFilters.active.value"
          :items="activeOptions"
          label="Status"
          multiple
        ></v-select>
      </v-card>
<!--      Store-->
      <v-card
        cols="12"
        class="mx-5 pl-3 pt-2"
      >
        Store
        <v-checkbox
          v-model="searchEnabledFilters.store"
          label="Use Store?"
        ></v-checkbox>
        <v-select
          v-model="searchFilters.store.value"
          :items="storeOptions"
          label="Store"
          multiple
        ></v-select>
      </v-card>
    </v-row>
  </v-navigation-drawer>
</template>

<script>
  // Utilities
  import { mapState, mapGetters, mapMutations } from 'vuex'
  import basicMixin from '../../mixins/basic'
  import {
    SEARCH_SET_ENABLED_FILTERS,
    SEARCH_SET_FILTERS,
  } from '../../store/mutations.types'

  export default {
    name: 'DashboardCoreDrawerDetails',
    mixins: [basicMixin],

    props: {
      expandOnHover: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
    }),

    computed: {
      ...mapState(['barColor', 'barImage']),
      ...mapGetters({
        activePage: 'activePage',
        userProfile: 'profile',
        searchFilters: 'search_filters',
        distanceOperators: 'search_distanceOperators',
        searchEnabledFilters: 'search_enabledFilters',
        serviceRates: 'search_serviceRates',
        towerOptions: 'search_towerOptions',
        activeOptions: 'search_activeOptions',
        storeOptions: 'search_storeOptions',
        apTypeOptions: 'search_apTypeOptions',
        radiusOptions: 'search_radiusOptions',
      }),
    },
    watch: {
      searchFilters: {
        handler: function (val, oldVal) {
          this.setFilters(val)
        },
        deep: true,
      },
      searchEnabledFilters: {
        handler: function (val, oldVal) {
          this.setEnabledFilters(val)
        },
        deep: true,
      },
    },

    methods: {
      ...mapMutations({
        setFilters: SEARCH_SET_FILTERS,
        setEnabledFilters: SEARCH_SET_ENABLED_FILTERS,
      }),
    },
  }
</script>

<style lang="sass">
  @import '~vuetify/src/styles/tools/_rtl.sass'

  #core-navigation-drawer
    .v-list-group__header.v-list-item--active:before
      opacity: .24

    .v-list-item
      &__icon--text,
      &__icon:first-child
        justify-content: center
        text-align: center
        width: 20px

        +ltr()
          margin-right: 24px
          margin-left: 12px !important

        +rtl()
          margin-left: 24px
          margin-right: 12px !important

    .v-list--dense
      .v-list-item
        &__icon--text,
        &__icon:first-child
          margin-top: 10px

    .v-list-group--sub-group
      .v-list-item
        +ltr()
          padding-left: 8px

        +rtl()
          padding-right: 8px

      .v-list-group__header
        +ltr()
          padding-right: 0

        +rtl()
          padding-right: 0

        .v-list-item__icon--text
          margin-top: 19px
          order: 0

        .v-list-group__header__prepend-icon
          order: 2

          +ltr()
            margin-right: 8px

          +rtl()
            margin-left: 8px
</style>
